import { MongoAbility, RawRuleOf } from '@casl/ability';

export type CaslAction =
  | 'manage'
  | 'read'
  | 'create'
  | 'update'
  | 'delete'
  | 'send'
  | 'createReport'
  | 'bulkDelete'
  | 'createModule'
  | 'createMasterList'
  | 'editPermissions'
  | 'manageApproval'
  | 'manageVerification'
  | 'readGeneral'
  | 'impersonateUser'
  | 'managePermissions'
  | 'manageBranches'
  | 'readContent'
  | 'readMatrix'
  | 'manageMatrix'
  | 'move'
  | 'archive'
  | 'unarchive'
  | 'upload';

export type CaslSubject =
  | 'all'
  | 'Document'
  | 'Record'
  | 'RecordManagement'
  | 'DocumentManagement'
  | 'Directory'
  | 'Training'
  | 'ValidityHistory'
  | 'OperationLog'
  | 'Notification'
  | 'NoticeHistory'
  | 'Homologation'
  | 'Admin';

export type Subjects = CaslSubject | { __typename: CaslSubject; [key: string]: unknown };

export type AppAbility = MongoAbility<[CaslAction, Subjects]>;

export type AppRawRule = RawRuleOf<AppAbility>;

export function detectSubjectType(subject: {
  __typename: CaslSubject;
  [key: string]: unknown;
}): CaslSubject {
  return subject.__typename;
}
